var React = require('react');

function NotesSearchResult (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.838867 2.9414C0.838867 2.11298 1.51044 1.44141 2.33887 1.44141H9.41756C10.246 1.44141 10.9176 2.11298 10.9176 2.94141V6.15589L5.65874 11.8164H2.33887C1.51044 11.8164 0.838867 11.1448 0.838867 10.3164V2.9414Z","stroke":"black","key":0}),React.createElement("path",{"d":"M10.2714 6.27835L5.84755 11.043L5.84755 7.77835C5.84755 6.94993 6.51912 6.27835 7.34754 6.27835L10.2714 6.27835Z","fill":"white","stroke":"black","key":1})]);
}

NotesSearchResult.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = NotesSearchResult;

NotesSearchResult.default = NotesSearchResult;
